module.exports = __webpack_public_path__ + "static/media/video-camera_g.0781215c.png";